import React from 'react';
import { usePermissionControl } from '@/hooks/usePermissionControl';
import { ACTION_CONTROL } from '@/constants/action-permission';

interface PermissionLinkProps {
  permissionKey: ACTION_CONTROL;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * 权限链接组件
 * 用于表格操作列的权限控制
 */
const PermissionLink: React.FC<PermissionLinkProps> = ({
  permissionKey,
  onClick,
  children,
  className,
  style,
}) => {
  const { handlePermissionClick } = usePermissionControl();

  const handleClick = () => {
    handlePermissionClick(permissionKey, onClick);
  };

  return (
    <a className={className} style={style} onClick={handleClick}>
      {children}
    </a>
  );
};

export default PermissionLink;
